export default "__VITE_ASSET__C69fgHJ9__"